import React from 'react';
import WarehousesList from './WarehousesList';

const WarehousesAndStorage = () => {
  return <WarehousesList />;
};

export default WarehousesAndStorage;